import Button from 'components/atoms/Button';
import Form from 'react-bootstrap/Form';
import { styled } from 'styled-components';

export const ButtonRow = styled(Form.Group)`
  margin-top: 10vh;
`;

export const StyledRoudedEdgesButton = styled(Button)`
  border-radius: 100px;

  &:disabled {
    > svg {
      path {
        stroke: ${({ theme }) => theme.colors.lightGrey};
      }
    }
  }
`;

export const StyledInput = styled(Form.Control)`
  min-height: 38px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const StyledFormLabel = styled(Form.Label)`
  color: ${({ theme }) => theme.colors.deepPurple};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;
